import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Location = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="location icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 2C14 0.89543 13.1046 0 12 0C10.8954 0 10 0.89543 10 2V3.1787C6.62049 3.94556 3.9633 6.6142 3.21308 10H2C0.89543 10 0 10.8954 0 12C0 13.1046 0.89543 14 2 14H3.23319C4.00981 17.3437 6.65003 19.9725 10 20.7327V22C10 23.1046 10.8954 24 12 24C13.1046 24 14 23.1046 14 22V20.7327C17.35 19.9725 19.9902 17.3437 20.7668 14H22C23.1046 14 24 13.1046 24 12C24 10.8954 23.1046 10 22 10H20.7869C20.0367 6.6142 17.3795 3.94556 14 3.1787V2ZM11.643 6.96824C11.7589 6.9891 11.8782 7 12 7C12.1218 7 12.2411 6.9891 12.357 6.96824C14.9518 7.15127 17 9.31429 17 11.9557C17 14.7171 14.7614 16.9557 12 16.9557C9.23858 16.9557 7 14.7171 7 11.9557C7 9.31429 9.04821 7.15127 11.643 6.96824Z"
    />
  </svg>
)
